import { render, staticRenderFns } from "./AddParamsInput.vue?vue&type=template&id=70864f5e&"
import script from "./AddParamsInput.vue?vue&type=script&lang=js&"
export * from "./AddParamsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports